module.exports = __webpack_public_path__ + "img/map.a4a4a05f.jpg";